module.exports = __webpack_public_path__ + "img/frame3.41e22604.jpg";